import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { Storefront } from '@mui/icons-material';
import { useAppTranslation } from '../i18n/useAppTranslation';

interface ContinueSellingRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Shopify "Continue selling when out of stock" (`settings.continueSellingWhenOutOfStock`,
 * the variant inventory_policy). One sentence per outcome so the store sees both.
 */
const ContinueSellingRow: React.FC<ContinueSellingRowProps> = ({ checked, onChange }) => {
  const { t } = useAppTranslation();
  const label = t('integrations.outOfStock.label');
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', py: 1.25 }}>
      <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center', mt: 0.25 }}>
        <Storefront fontSize="small" color="action" />
      </Box>
      <Box sx={{ flex: 1, mr: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {label}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.45 }}>
          {t('integrations.outOfStock.on')}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.45 }}>
          {t('integrations.outOfStock.off')}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.45, mt: 0.5 }}>
          {t('integrations.outOfStock.note')}
        </Typography>
      </Box>
      <Switch
        size="small"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        slotProps={{ input: { 'aria-label': label } }}
      />
    </Box>
  );
};

export default ContinueSellingRow;
